import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Splash } from './routes/Splash';
import { GuestUpload } from './routes/GuestUpload';
import { HostGallery } from './routes/HostGallery';
import './styles.css';

function Router() {
  const path = window.location.pathname.replace(/\/+$/, '');

  if (path === '' || path === '/') return <Splash />;

  const guest = path.match(/^\/e\/([a-z0-9-]{1,80})$/i);
  if (guest) return <GuestUpload slug={guest[1]} />;

  const host = path.match(/^\/g\/([a-z0-9-]{1,80})$/i);
  if (host) return <HostGallery slug={host[1]} />;

  return (
    <div className="page guest">
      <div className="shell guest-inner">
        <h1>Not here.</h1>
        <p className="lede">That page does not exist.</p>
        <p className="note">
          <a href="/">Everyone&rsquo;s Camera</a>
        </p>
      </div>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router />
  </StrictMode>,
);
